import { Component, ViewEncapsulation, input } from '@angular/core';

import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-system-changed-video-provider-template',
  styleUrls: ['../../global-styles.less', 'system-changed-video-provider.component.less'],
  templateUrl: './system-changed-video-provider.component.html',
  imports: [
    EmailLayoutComponent,
    EmailLinkComponent,
    EmailMarginComponent,
    EmailMessageHeaderComponent,
    EmailRecruiteeLogoComponent,
    EmailTextComponent,
    EmailImageAssetDirective,
  ],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class SystemChangedVideoProviderTemplateComponent {
  public readonly data = input.required<WrappedValue<SystemChangedVideoProviderTemplateData>>();
}

export type SystemChangedVideoProviderTemplateData = {
  title: string;
  sent_to_all_admins: string;
  p1_header: string;
  p1: string;
  p2_header: string;
  p2_1_html: string;
  p2_2_html: string;
  p2_3_html: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const SystemChangedVideoProviderTemplateMocks: SystemChangedVideoProviderTemplateData[] = [
  {
    title: 'There is a problem with your Google Meet integration',
    p1_header: "What's wrong?",
    p1: 'Your Google Meet integration in Recruitee is no longer working. Scheduled events won’t include a video interview link and will incorrectly be marked as "On-site interview”.',
    p2_header: 'How to fix it?',
    p2_1_html:
      'Go to the <a>Google Meet integration settings</a> and check if the integration is enabled',
    p2_2_html:
      'Go to the <a>Event scheduler settings</a> and reconnect video interviews to your existing scheduler links',
    p2_3_html:
      'Double-check your <a>upcoming events</a> – if you see that some were supposed to be a video interview, you will need to manually update the events and notify the candidate about the changes.',
    sent_to_all_admins:
      'This message was automatically sent to all administrators of your company. If the issue has already been fixed, you can ignore it.',
    footer: {
      text: 'Need help?',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
  },
];
